import { getResource, postForm } from './BaseRequests'

export const fetchUserDetails = (success, fail) => {
    getResource("member").then(success).catch(fail)
}

export const saveUserDetails = ({ memberDetails }, success, fail) => {
    postForm("update_member", {member: memberDetails}).then(success).catch(fail)
}

export const savePreferences = ({ preferences }, success, fail) => {
    postForm("update_preferences", {preferences: preferences}).then(success).catch(fail)
}

export const fetchUserExists = ({ email }, success, fail) => {
    getResource("member_check", {email: email}, 10, true).then(response =>{
        if(response.data && "is_existing_member" in response.data){
            return success(response.data.is_existing_member)
        }fail(response.data)
    }).catch(fail)
}

// TODO response not right
export const addMember = (memberDetails, success, fail) => {
    postForm("add_member", {member: memberDetails}).then(success).catch(fail)
}


//requests a password reset
export const requestPasswordReset = ({ email }, success, fail) => {
    postForm("request_password_reset", {email: email}).then(success).catch(fail)
}


//resets the password to a given value
export const resetPassword = ({ password, resetKey }, success, fail) => {
    postForm("reset_password", { password: password, reset_key:resetKey }).then(success).catch(fail)
}

export const fetchUserReferrals = (success, fail) => {
    //fetch both referrals and referral code

    //cache for 1 minute
    let getReferral = getResource("referrals", {}, 60)
    //cache for 1 day
    let getReferralCode = getResource("referral_code", {}, 60 * 60 * 24)

    Promise.all([getReferral, getReferralCode]).then(([referrals, referral_code]) => {
        success({referrals: referrals, referral_code: referral_code})
    }).catch(fail)
}

export const fetchUserPoints = (success, fail) => {
    getResource("points", {}, 30).then(success).catch(fail)
}

export const fetchUpgradeInfo = () => {
    return getResource("price_to_upgrade")
}

export const postReferFriend = ({name, email,message},success, fail)=>{
  postForm("refer", {name: name, email: email,message:message}).then(success).catch(fail)
}


export const postPriceRequest = (info, success, fail) =>{
    postForm("price_request", info).then(success).catch(fail)
}

export const postPaymentPlanRequest = ({member_name,member_email,member_id},success,fail)=>{
  postForm("paymentPlan_request", {member_name: member_name, member_email: member_email,member_id: member_id}).then(success).catch(fail)
}

export const postReturns = ({name, email, homephone, cellphone, member_id, brand, productName, productDesc,reason,issueDesc}, success, fail)=>{
  // console.log({
  //   name: name,
  //   email: email,
  //   homephone: homephone,
  //   cellphone: cellphone,
  //   member_id: member_id,
  //   brand: brand,
  //   productName: productName,
  //   productDesc: productDesc,
  //   reason: reason,
  //   issueDesc: issueDesc
  // })
  postForm(
    "returns",
    {
      name: name,
      email: email,
      homephone: homephone,
      cellphone: cellphone,
      member_id: member_id,
      brand: brand,
      productName: productName,
      productDesc: productDesc,
      reason: reason,
      issueDesc: issueDesc
    }
  ).then(success).catch(fail)
}

export const fetchPreferenceOptions = (success, fail) => {
	getResource("preferences").then(success).catch(fail)
	// return {
	// 	"Building/Renovations": false,
	// 	"Furniture": false,
	// 	"Family": false,
	// 	"Home Decor": false,
	// 	"Home Appliances": false,
	// 	"Baby": false,
	// 	"Toys and Educational": false,
	// 	"Electronics": false,
	// 	"Health and Beauty": false,
	// 	"Eco Friendly Cleaning": false,
	// 	"Organic/Gluten and Dairy Free Foods": false,
	// 	"Sports and Outdoor": false,
	// }
}